var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.9383,
    cy: 32.1394,
    r: 31.4422,
    fill: "#0A66C2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4207 52.934V34.8439H41.493L42.4021 27.7939H35.4207V23.2926C35.4207 21.2514 35.9877 19.8604 38.9148 19.8604L42.6481 19.8588V13.5533C42.0021 13.4674 39.7861 13.2754 37.2081 13.2754C31.8254 13.2754 28.1405 16.5609 28.1405 22.5946V27.7939H22.0527V34.8439H28.1405V52.934H35.4207Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebookIcon.68044c2427812edcb065e959a60751ad.svg";
export { ForwardRef as ReactComponent };